import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updatePacientePruebaAlergia } from "../services/pruebaalergia.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const usePacientePruebaAlergiaEditar = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const updatePruebaAlergiaMutation = useMutation({
        mutationFn: updatePacientePruebaAlergia,
        onSuccess: (prueba, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['paciente/pruebaAlergia', id] });
            variables.success();
            dispatch(successNotification('Prueba de alergia editada'));
        },
        onError: (error, variables, context) => {
            // console.log(error);
            dispatch(dangerNotification(error.message));
        },
    });

    return {
        updatePruebaAlergiaMutation,
    }
}